<div class="account-container">
  <h2>Account Information</h2>

  <div *ngIf="user" class="account-details">
    <div class="profile-section" *ngIf="user.picture">
      <img [src]="user.picture" alt="Profile Picture" class="profile-picture">
    </div>

    <div class="info-grid">
      <div class="info-label">Name:</div>
      <div class="info-value">{{ getFullName() }}</div>

      <div class="info-label">Email:</div>
      <div class="info-value">{{ getEmail() }}</div>

      <div class="info-label">Role:</div>
      <div class="info-value">{{ getRoleName(user.role) }}</div>

      <div class="info-label">User ID:</div>
      <div class="info-value">{{ getUserId() }}</div>

      <div class="info-label">Phone Number:</div>
      <div class="info-value">{{ user.phoneNumber || 'Not provided' }}</div>

      <div class="info-label">SMS Opt-In:</div>
      <div class="info-value">
        <input type="checkbox" [(ngModel)]="user.smsOptIn">
        <span class="opt-in-text">By Checking, I agree to receive text messages from Vertical Talent for business notifications and alerts.</span>
      </div>

      <div class="info-label">Token Expires:</div>
      <div class="info-value">{{ getTokenExpirationDate() }}</div>
    </div>
  </div>

  <div *ngIf="!user" class="no-user">
    <p>No user information available. Please log in.</p>
  </div>
</div>
